const url = "./assets/page/steps/step5/icons/";

const options = [
    {
        content: " ",
        icon: true,
        text: "Nenhuma",
        url: `${url}fruit_any.svg`,
    },
    {
        content: "strawberry",
        icon: true,
        text: "Morango",
        url: `${url}fruit_strawberry.svg`,
    },
    {
        content: "banana",
        icon: true,
        text: "Banana",
        url: `${url}fruit_banana.svg`,
    },
    {
        content: "kiwi",
        icon: true,
        text: "Kiwi",
        url: `${url}fruit_kiwi.svg`,
    },
    {
        content: "graper",
        icon: true,
        text: "Uva",
        url: `${url}fruit_graper.svg`,
    },
];

export default options;
